"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.Loader = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styledIs = _interopRequireDefault(require("../../utils/styled-is"));
var _variables = require("../../styles/variables");
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _animations = require("../../styles/animations");
var _templateObject;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var Wrapper = exports.Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "HBLoaderstyles__Wrapper",
  componentId: "sc-1utlz13-0"
})(["", ""], (0, _styledIs["default"])('floatCenter')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n        transform: translate(-50%, -50%);\n        position: absolute;\n        z-index: ", ";\n        left: 50%;\n        top: 50%;\n    "])), _variables.Z_INDEX.LOADER));
function getSize(size) {
  switch (size) {
    case 'large':
      return (0, _styledComponents.css)(["height:80px;width:80px;border-width:6px;"]);
    case 'medium':
      return (0, _styledComponents.css)(["height:40px;width:40px;border-width:4px;"]);
    case 'small':
      return (0, _styledComponents.css)(["height:24px;width:24px;border-width:2px;"]);
    case 'xxs':
      return (0, _styledComponents.css)(["height:12px;width:12px;border-width:2px;"]);
    case 'xs':
    default:
      return (0, _styledComponents.css)(["height:16px;width:16px;border-width:2px;"]);
  }
}
var Loader = exports.Loader = _styledComponents["default"].div.withConfig({
  displayName: "HBLoaderstyles__Loader",
  componentId: "sc-1utlz13-1"
})(["padding:0;border:2px solid ", ";border-right:2px solid ", ";border-bottom:2px solid ", ";border-left:2px solid ", ";border-radius:100%;height:50px;width:50px;animation:", " 0.5s infinite linear;", ""], _colors["default"].neutral400, function (props) {
  return props.color;
}, function (props) {
  return props.color;
}, function (props) {
  return props.color;
}, _animations.spin, function (props) {
  return getSize(props.size);
});
//# sourceMappingURL=HBLoader.styles.js.map